import { Component, h, Prop } from '@stencil/core'
import './udp-calendar-year.css'

@Component({
  tag: 'udp-calendar-year',
  styleUrl: 'udp-calendar-year.css',
  shadow: true,
})
export class UdpCalendarYear {
  @Prop() props: any = {}

  componentWillLoad() { 
    
  }

  render() {
    return (
      <udp-calendar-base initialView='dayGridYear' {...this.props}></udp-calendar-base>
    )
  }
}
